// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xcVo","title":"Info_title__1twbh","links":"Info_links__1sv0w","link":"Info_link__28WxC","logo":"Info_logo__1DkJq"};